import { Link } from "react-router-dom";
import { ArrowRight, Camera } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import BackNav from "@/components/BackNav";

const VASE_IMG = "https://images.unsplash.com/photo-1642350371707-510555b9c478?w=900&q=80";

export default function Fotografia() {
  const { user } = useAuth();

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 space-y-10" data-testid="page-fotografia">
      <BackNav />

      <div className="grid gap-10 lg:grid-cols-2 items-center">
        <div className="space-y-6">
          <div>
            <p className="eyebrow mb-2">Servizio</p>
            <h1 className="font-serif text-4xl sm:text-5xl text-navy mb-4">Fotografia dell'intervento</h1>
            <p className="text-body leading-relaxed">
              Al termine di ogni visita ricevi nella tua area riservata la fotografia dell'intervento
              effettuato: la prova semplice e sincera che siamo stati lì per te.
            </p>
          </div>
          <ul className="space-y-3 text-sm text-body">
            <li className="flex items-start gap-2"><Camera size={16} className="text-[#4a7c59] mt-0.5 shrink-0" />Inclusa in ogni intervento, senza costi aggiuntivi</li>
            <li className="flex items-start gap-2"><Camera size={16} className="text-[#4a7c59] mt-0.5 shrink-0" />Disponibile nella tua area riservata, insieme allo storico</li>
            <li className="flex items-start gap-2"><Camera size={16} className="text-[#4a7c59] mt-0.5 shrink-0" />Con data, servizio effettuato ed eventuali note del professionista</li>
          </ul>
          <p className="font-serif text-2xl text-navy italic">“Siamo stati lì per te.”</p>
          <Link to={user ? "/checkout?type=singola" : "/accedi"} data-testid="fotografia-cta" className="btn-primary">
            Richiedi un intervento <ArrowRight size={16} />
          </Link>
        </div>
        <img src={VASE_IMG} alt="Fotografia dell'intervento effettuato" className="rounded-3xl object-cover w-full aspect-[4/3]" data-testid="fotografia-image" />
      </div>
    </div>
  );
}
